import { ViewportScroller } from '@angular/common';
import {
  DOCUMENT,
  inject,
  Injectable,
  Renderer2,
  RendererFactory2,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { LoadingIndicatorService } from './loading-indicator.service';

@Injectable({ providedIn: 'root' })
export class DialogScrollService {
  private rendererFactory = inject(RendererFactory2);
  private document = inject<Document>(DOCUMENT);
  private scroller = inject(ViewportScroller);
  private loadingService = inject(LoadingIndicatorService);

  private renderer: Renderer2;
  scrollY: number = null;
  dialogOpen = new BehaviorSubject(false);

  constructor() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  dialogOpened() {
    if (this.dialogOpen.value) {
      return;
    }
    this.dialogOpen.next(true);
    this.scrollY = window.scrollY;
    this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
  }

  dialogClosed() {
    if (this.scrollY === null || this.loadingService.getLoadingCount() > 0) {
      return;
    }
    this.renderer.removeStyle(this.document.body, 'overflow');
    this.dialogOpen.next(false);
    this.scroller.scrollToPosition([0, this.scrollY]);
    this.scrollY = null;
  }
}
